import { Login as BluBlocksLogin } from "@bluframe/blublocks"

import { ComponentProps } from "."
import { Logo, Wrapper } from "./styled"

const Login = ({ isLoading, onSubmitLogin }: ComponentProps) => (
  <Wrapper>
    <Logo
      alt="Mighty Chroma Logo"
      src="https://snowflakes.blufra.me/sites/mightychroma.me/content/xsmall_mighty_chroma_logo_vertical_glossy_e9852568a7.png"
    />

    <BluBlocksLogin
      isLoading={isLoading}
      name="Welcome to Mighty Chroma"
      onSubmitLogin={onSubmitLogin}
    />
  </Wrapper>
)

export default Login
